export const plats = [
    {
        id: "entrees",
        plat: [
            "1. Nems au poulets(4p) – Nem gà",
            "2. Nems aux crevettes(4p) – Nem tôm",
            "3. Nems végétarien(4p) – Nem chay",
            "4. Samossas au boeuf(4p)",
            "5. Beignets aux légumes – Rau chiên",
            "6. Crevettes pannées(4p) – Tôm chiên xù",
            "7. Assortiment de friture(p) | (Nem, samossa, crevette, pannée)",
            "8. Raviolis vietnamiens au porc - Bánh cuốn thịt",
            "9. Raviolis vietnamiens au crevette - Bánh cuốn tôm",
            "10. Rouleaux de printemps aux crevettes - Gỏi cuốn tôm",
            "11. Rouleaux de printemps aux boeufs - Gỏi cuốn bò",
            "12. Salade de poulet grillé piquante - Gỏi gà cay",
            "13. Salade de boeuf saignant au citron - Gỏi bò tái chanh",
            "14. Salade de crevettes - Gỏi tôm",
            "15. Salade de mangue aux crevettes / boeufs - Gỏi tôm xoài / bò xoài",
            "16. Salade à l’ananas aux crevettes - Gỏi tôm dứa",
            "17. Soupe aux raviolis aux crevettes - Sủi cảo",
        ],
        prix: [
            "7.00€",
            "7.00€",
            "7.00€",
            "7.00€",
            "7.00€",
            "8.00€",
            "12.00€",
            "7.00€",
            "8.00€",
            "6.00€",
            "6.00€",
            "10.00€",
            "10.00€",
            "10.00€",
            "12.00€",
            "12.00€",
            "7.00€",
        ]
    },
    {
        id: "soupes",
        plat: [
            "1. Soupe phở spéciale - Phở đặc biệt (pâte de riz, boeuf cuit, boeuf saignant, boulettes de boeuf)",
            "2. Soupe phở au boeuf cuit / boulette de boeuf - Phở tái chín",
            "3. Soupe phở saté (boeuf cuit / saignant / boulette de boeuf)",
            "4. Soupe phở au poulet - Phở gà",
            "5. Soupe piquante impérial de HUE - Bún bò Huế (vermicelle de riz, pied de cochon, jambonneau, boeuf)",
            "6. Soupe saigonnaise - Hủ tiếu nước (pâte de riz, crevettes, porc, oeuf de caille)",
            "7. Soupe crevette au lait de coco, citronnelle, pâte de riz",
            "8. Soupe aux raviolis aux crevettes et nouilles - Sủi cảo mỹ",
        ],
        prix: [
            "12.00€",
            "11.00€",
            "11.00€",
            "11.00€",
            "13.00€",
            "12.00€",
            "13.00€",
            "11.00€",
        ]
    },
    {
        id: "bo_bun",
        plat: [
            "B1. Bò bún nem – Vermicelle de riz au boeuf sauté avec nems",
            "B2. Bò bún – Vermicelle au boeuf sauté",
            "B3. Bò nem – Vermicelle au nem",
            "B4. Bún bò lụi – Vermicelle au boeuf grillé",
            "B5. Bún gà nem – Vermicelle au poulet grillé avec nem",
            "B6. Bún heo nem – Vermicelle au porc grillé avec nem",
            "B7. Bún tôm – Vermicelle aux crevettes",
            "B8. Bún tofu – Vermicelle de riz au tofu sauté c'itronnelle",
        ],
        prix: [
            "12.00€",
            "11.00€",
            "11.00€",
            "11.00€",
            "12.00€",
            "11.00€",
            "12.00€",
            "10.00€",
        ]
    },
    {
        id: "nouilles",
        plat: [
            "N1. Nouilles sautées aux boeufs avec légumes - Mỳ xào bò",
            "N2. Nouilles sautées aux crevettes avec légumes - Mỳ xào tôm",
            "N3. Nouilles sautées aux poulets avec légumes - Mỳ xào gà",
            "N4. Nouilles sautées aux légumes - Mỳ xào rau",
            "N5. Nouilles croustillantes aux boeufs avec légumes - Mỳ xào giòn bò",
            "N6. Nouilles croustillantes aux crevettes avec légumes - Mỳ xào giòn tôm",
            "N7. Nouilles croustillante aux poulets avec légumes - Mỳ xào giòn gà",
            "N8. Nouilles croustillantes aux légumes - Mỳ xào giòn rau",
            "N9. Pâte de riz sauté aux poulets / boeufs / crevettes avec légumes - Phở xào gà / bò / tôm",
        ],
        prix: [
            "13.00€",
            "13.00€",
            "13.00€",
            "12.00€",
            "13.00€",
            "13.00€",
            "13.00€",
            "12.00€",
            "13.00€",
        ]
    },
    {
        id: "specialites",
        plat: [
            "S1. Porc grillé Ha Noi - Bún chả Hà Nội ~ accompagné de vermicelle de riz, de salade verte et d’herbes aromatiques",
            "S2. Crêpe vietnamienne (soja, porc et/ou crevettes) - Bánh xèo",
            "S3. Soufflé de crevettes sur lit de canne à sucre - Chạo tôm",
            "S4. Poissons caramélisés - Cá kho",
            "S5. Tranche de boeuf roulé aux feuilles de lá lốt grillé - Bò lá lốt",
            "S6. Crevettes au lait de coco piquant - Tôm nước dừa",
            "S7. Crevettes au curry - Tôm cà ri",
            "S8. Crevettes au sel et poivre - Tôm muối tiêu",
            "S9. Crevettes caramélisées en marmite - Tôm rim",
            "S10. Marmite de boeuf sauté à la sauce piquante - Bò xào cay",
        ],
        prix: [
            "14.00€",
            "15.00€",
            "15.00€",
            "12.00€",
            "14.00€",
            "13.00€",
            "13.00€",
            "15.00€",
            "15.00€",
            "13.00€",
        ]
    },
    {
        id: "plats_complets",
        plat: [
            "1. Luc lac au boeuf poêlé, riz rouge, oeuf - Cơm bò lúc lắc",
            "2. Brochettes de boeuf grillé, riz - Cơm bò lụi",
            "3. Boeuf sauté aux oignons, riz - Cơm bò xào hành",
            "4. Porc grillé à la citronnelle, riz - Cơm thịt nướng xả",
            "5. Cuisse de poulet grillé à la citronnelle, riz - Cơm đùi gà nướng xả",
            "6. Brochettes de poulet caramélisé, riz - Cơm gà xiên",
            "7. 3 viandes grillées, riz (porc, poulet, boeuf) - Cơm 3 loại thịt",
            "8. Brochettes de crevettes grillés, riz - Cơm tôm lụi",
            "9. Crevettes sautées à la sauce piquante, riz - Cơm tôm xào cay",
        ],
        prix: [
            "14.00€",
            "12.00€",
            "12.00€",
            "12.00€",
            "12.00€",
            "10.00€",
            "14.00€",
            "14.00€",
            "14.00€",
        ]
    },
    {
        id: "plats_vegetariens",
        plat: [
            "1. Nems aux légumes",
            "2. Beignets aux légumes",
            "3. Tofus frits",
            "4. Nouilles sautées aux légumes",
            "5. Nouilles croustillantes sautées aux légumes",
            "6. Pâtes de riz sautées aux légumes",
            "7. Marmite de tofus sautés",
            "8. Marmite de tofu caramélisé",
            "9. Marmite de tofu au curry",
            "10. Marmite de tofu au lait de coco",
            "11. Tofus sautés piquant à la citronnelle",
            "12. Bún tofu ~ (vermicelles de riz, tofus sautés, salades, carottes, concombres, mentes, oignon frits)",
            "13. Marmite de légume au curry",
            "14. Marmite de légume au lait de coco",
            "15. Marmite de légume à la sauce piquante",
            "16. Bún nem légume",
        ],
        prix: [
            "7.00€",
            "7.00€",
            "7.00€",
            "12.00€",
            "12.00€",
            "12.00€",
            "10.00€",
            "10.00€",
            "10.00€",
            "10.00€",
            "10.00€",
            "10.00€",
            "10.00€",
            "10.00€",
            "10.00€",
            "10.00€",
        ]

    },
    {
        id: "accompagnement",
        plat: [
            "1. Nems aux légumes",
            "2. Beignets aux légumes",
            "3. Tofus frits",
            "4. Nouilles sautées aux légumes",
            "5. Nouilles croustillantes sautées aux légumes",
            "6. Pâtes de riz sautées aux légumes",
            "7. Marmite de tofus sautés",
            "8. Marmite de tofu caramélisé",
            "9. Marmite de tofu au curry",
            "10. Marmite de tofu au lait de coco",
            "11. Tofus sautés piquant à la citronnelle",
            "12. Bún tofu ~ (vermicelles de riz, tofus sautés, salades, carottes, concombres, mentes, oignon frits)",
            "13. Marmite de légume au curry",
            "14. Marmite de légume au lait de coco",
            "15. Marmite de légume à la sauce piquante",
            "16. Bún nem légume",
        ],
        prix: [
            "7.00€",
            "7.00€",
            "7.00€",
            "12.00€",
            "12.00€",
            "12.00€",
            "10.00€",
            "10.00€",
            "10.00€",
            "10.00€",
            "10.00€",
            "10.00€",
            "10.00€",
            "10.00€",
            "10.00€",
            "10.00€",
        ]
    },
    {
        id: "sandwich",
        plat: [
            "1. Sandwich normal",
            "2. Sandwich spéciale",
        ],
        prix: [
            "4.00€",
            "5.00€",

        ]
    },
];

export const boissons_items = [
    {
        id: "boissons",
        boissons: {
            boisson: [
                "Evian, Badoit, San Pellegrino 1L",
                "Evian, Badoit, San Pellegrino 0.5L",
                "Perrier 33cl",
                "Coca, Orangina",
                "Jus de fruits (orange, ananas, abricot)",
                "Jus de coco frais",
                "Orange pressée",
                "Boisson au soja",
                "Thé jasmin",
                "Thé glacé",
                "Thé au citron glacé",
                "Bière Heineken",
                "Bière Saïgon - Saigon",
                "Bière Hanoï - Hà Nội",
                "Café glacé Net Viêt (café, lait)",
                "Café",
            ],
            prix: [
                "5.00€",
                "3.00€",
                "4.00€",
                "4.00€",
                "4.00€",
                "4.00€",
                "4.50€",
                "4.00€",
                "2.50€",
                "2.50€",
                "3.50€",
                "4.00€",
                "4.50€",
                "4.50€",
                "4.50€",
                "2.00€",
            ]
        },
        autres: [
            {
                titre: "Bubble Tea (Moyenne/Grande)",
                elements: [
                    "Brown sugar",
                    "Mangue",
                    "Fruit de passion",
                    "Abricot",
                    "Fraise ",
                    "Pêche  ",
                ],
                prix: [
                    "4.50€/5.50€",
                    "4.50€/5.50€",
                    "4.50€/5.50€",
                    "4.50€/5.50€",
                    "4.50€/5.50€",
                    "4.50€/5.50€",
                ]

            }
        ]
    },
];

export const vins = [
    {
        titre: "Vins Rouges AOC (75cl/37,5)",
        items: [
            {
                sous_titre: "Bourgogne",
                vin: [
                    "Bourgogne Domaine Dupuis"
                ],
                prix: [
                    "22.00€/14.00€",
                ]
            },
            {
                sous_titre: "Beaujolais",
                vin: [
                    "Brouilly"
                ],
                prix: [
                    "26.00€/15.00€",
                ]
            },
            {
                sous_titre: "Val de Loire",
                vin: [
                    "Touraine",
                    "Saumur",
                ],
                prix: [
                    "16.00€/10.00€",
                    "20.00€/12.00€",
                ]
            },
            {
                sous_titre: "Valée du Rhône",
                vin: [
                    "Côtes du Rhône",
                    "Vacqueyras",
                ],
                prix: [
                    "16.00€/10.00€",
                    "20.00€/12.00€"
                ]
            },
            {
                sous_titre: "Bourgogne",
                vin: [
                    "Bordeaux",
                    "Haut-Médoc",
                    "Lussac Saint Emilion",
                ],
                prix: [
                    "18.00€/11.00€",
                    "26.00€/15.00€",
                    "26.00€/15.00€",
                ]
            },
        ]
    },
    {
        titre: "Vins Blancs AOC (75cl/37,5)",
        items: [
            {
                sous_titre: "Val de Loire",
                vin: [
                    "Cheverny",
                    "Sancerre",
                ],
                prix: [
                    "18.00/11.00€",
                    "31.00/17.00€",
                ]
            },
            {
                sous_titre: "Alsace",
                vin: [
                    "Riesling"
                ],
                prix: [
                    "20.00€/12.00€",
                ]
            },
        ]
    },
    {
        titre: "Vins Roses AOC (75cl/37,5)",
        items: [
            {
                sous_titre: "Provence",
                vin: [
                    "Côte de provence",
                    "Bandol",
                ],
                prix: [
                    "16.00/10.00€",
                    "31.00/18.00€",
                ]
            },
        ]
    },
    {
        titre: "Vins en pichet ~ Blanc, Rosé ou Rouge (50cl / 25cl / 1 verre)",
        items: [
            {
                sous_titre: "Provence",
                vin: [
                    "50 cl",
                    "25 cl",
                    "1 verre",
                ],
                prix: [
                    "7.00€",
                    "4.00€",
                    "3.00€",
                ]
            },
        ]
    },
];

export const menus = [
    {
        id: "menu_degustation_25",
        title: "Menu dégustation 25.00€",
        mode: 1,
        entrees: [
            "Raviolis vietnamiens aux porcs à la vapeur",
            "Salade de bœuf saignant au citron",
            "Salade de bœuf grillé piquant",
            "Assortiments de fritures (nem, samoussa, crevette panée)",
        ],
        plats: [
            "Assortiment de grillades (brochettes de crevettes, bœufs, poulet)",
            "Canard sauté à la mangue fraiche (ou ananas frais)",
            "Poulet au lait de coco à la sauce piquante",
        ],
        accompagnement: [
            "Riz sauté ananas",
            "Riz sauté maison  (pâté de porc, saucisson au porc, omelette, ciboulette, …)",
            "Nouilles sautées natures",
        ],
        boissons: [
            "Rouge ou rose ou blanc (25cl)",
            "Bière au choix",
            "Coca",
            "Jus de fruits",
        ],
        desserts: [
            "Dessert maison avec café",
            "Glace (2 boules) avec café",
        ]
    },
    {
        id: "menu_midi_14",
        title: "Menu midi 14.00€",
        mode: 2,
        type: [
            {
                title: "Normal",
                entrees: [
                    "Nems aux poulets ou crevettes",
                    "Samoussas aux bœufs",
                    "Salade de poulets grillés et/ou crevettes",
                    "Raviolis aux porcs vietnamiens",
                    "Soupe de raviolis aux crevettes",

                ],
                plats: [
                    "Phở bœuf cuit et/ou saignant",
                    "Riz au porc caramélisé - Cơm thịt kho",
                    "Riz au poulet curry - Cơm gà cà ri",
                    "Riz aux brochettes de bœufs grillées - Cơm bò lụi",
                    "Riz aux crevettes sautées à la sauce piquante - cơm tôm xào cay",

                ],
            },
            {
                title: "Végétarien",
                entrees: [
                    "Nems aux légumes",
                    "Beignets aux légumes",


                ],
                plats: [
                    "Riz aux légumes au curry",
                    "Riz aux légumes à la sauce piquante",
                    "Riz aux légumes vertes sautés",
                ],
            }
        ],
        desserts: [
            "Dessert maison avec café",
            "Glace (2 boules) avec café",
        ]
    },
    {
        id: "menu_midi_12",
        title: "Menu midi 12.00€ (seulement le samedi)",
        mode: 2,
        entrees: [
            "Nems aux poulets",
            "Nems aux crevettes",
            "Samoussas aux bœufs",
            "Salade de poulets grillés",
            "Raviolis vietnamiens",

        ],
        plats: [
            "Phở bœuf cuit ou saignant",
            "Vermicelle de riz aux bœufs sautés - Bò bún",
            "Riz aux porcs grillé à la citronnelle - Cơm thịt nướng sả",
            "Riz à la cuisse de poulet grillé à la citronnelle - Cơm gà nướng sả",

        ],
        desserts: [
            "Dessert maison avec café",
            "Glace (2 boules) avec café",
        ]
    },
    {
        id: "menu_enfant",
        title: "Menu enfant (< 10 ans) 12.00€",
        mode: 2,
        entrees: [
            "Nems aux poulets",
            "Nems aux crevettes",


        ],
        plats: [
            "Riz à la cuisse de poulet grillé à la citronnelle",
            "Riz aux brochettes de poulets caramélisés",
            "Riz aux brochettes de bœufs grillés",


        ],
        desserts: [
            "Glace (petit pot de fraise + vanille ou chocolat, vanille)",
        ]
    },
];

export const desserts = [
    {
        id: "dessert",
        dessert: [
            "1. Nougat tendre aux sésames – Kẹo mè xửng",
            "2. Gingembre confit - Mứt gừng",
            "3. Lychee sirop",
            "4. Mangue fraiche - Xoài tươi",
            "5. Ananas fraiche - Dứa tươi",
            "6. Dessert maison : Bacota(banane au lait de coco et perles de tapioca)",
            "7. Gâteau de riz maison napée au lait de coco avec mangue fraiche - Xôi xoài",
            "8. Perle de coco",
            "9. Dessert 3 couleurs - Chè ba màu",

        ],
        prix: [
            "5.00€",
            "5.00€",
            "4.00€",
            "8.50€",
            "8.50€",
            "6.00€",
            "7.00€",
            "6.00€",
            "6.00€",
        ],
        sous_cat: {
            title: "Glaces",
            dessert: [
                "10. Noix de coco givrée",
                "11. Orange givrée",
                "12. Citron givré",
                "13. Petit pot vanille / fraise / chocolat",
                "14. Sorbet parfumé 2 boules / 3 boules (vanille, chocolat, mangue, coco, fraise, framboise, passion, citron, rhum raisin)",
            ],
            prix: [
                "6.00€",
                "6.00€",
                "6.00€",
                "3.5.00€",
                "5.00€ / 6.00€",
            ]
        }
    },
];
